module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"choose":"Choose an image","clear":"Clear","flip":"Flip","rotate":"Rotate","save":"@:labels.save"},"fr":{"choose":"Choisissez une image","clear":"Vider","flip":"Renverser","rotate":"Tourner","save":"@:labels.save"}}')
  delete Component.options._Ctor
}
